module.exports = __webpack_public_path__ + "assets/img/oneForOne_2.7f6454d5.png";